import React from 'react';
import { SettingsItem } from 'design-system/SettingsItem';
import IconTransfer from 'design-system/icons/IconTransfer';
import { IconActivity } from 'design-system/icons';
import { rem, Spacer } from 'design-system';
import Modal from 'utils/packages/Modal';
import PayIcon from '../icons/PayIcon';
import RequestIcon from '../icons/RequestIcon';
import { isWeb } from '../../../constants';
const PayOptionsModalContent = ({ onPressPay, onPressRequest, onPressTransfer, onPressActivity, }) => (<>
    <Spacer.H8 />
    <SettingsItem title="Pay someone" description="Send via bank transfer or QR code" icon={<PayIcon colorKey="statusNegative"/>} onPress={() => PayOptionsModal.hide(onPressPay)}/>
    <SettingsItem title="Request money" description="Ask someone to pay you back" icon={<RequestIcon colorKey="statusPositive"/>} onPress={() => PayOptionsModal.hide(onPressRequest)}/>
    <SettingsItem title="Move money" description="Transfer between your own accounts" icon={<IconTransfer colorKey="brand"/>} onPress={() => PayOptionsModal.hide(onPressTransfer)}/>
    <SettingsItem title="See activity" description="Check your past payments and transfers" icon={<IconActivity gradientKey="pro"/>} onPress={() => PayOptionsModal.hide(onPressActivity)}/>
  </>);
const PayOptionsModal = {
    show: (props) => {
        Modal.show(<PayOptionsModalContent {...props}/>, {
            title: 'Pay, request or move money',
            containerStyle: { paddingHorizontal: isWeb ? rem(8) : 0 },
        });
    },
    hide: Modal.hide,
};
export default PayOptionsModal;
